import { fetcher } from "../fetcher";

type NotificationParams = {
  per_page: number;
  order_by?: "read_at" | "created_at";
  order_direction?: "asc" | "desc";
};

type NotificationReadParams = {
  notification_id: string | number;
};

export const notificationsService = {
  getNotifications: async (params: NotificationParams) => {
    return await fetcher(`/notifications`, {
      method: "GET",
      params,
      schema: notificationsSchema,
    });
  },
  notificationRead: async (payload: NotificationReadParams) => {
    return await fetcher(`/notifications/${payload.notification_id}/read`, {
      method: "POST",
      schema: singleNotificationSchema,
      meta: true,
    });
  },
};
